import { LayoutColors } from '@src/core/theme';
import { BodySmallMedium } from '@src/fonts/typography/Typography';
import styled, { css } from 'styled-components';

export const InputSpacing = css`
  border: 1px solid ${LayoutColors.blackLight};
  border-radius: 4px;
  padding: 10px;
  box-sizing: border-box;
  padding: 10px;
`;

export const InputArea = styled.div`
  display: block;
`;

interface InputLabelProps {
  htmlFor?: string;
}

export const InputLabel = styled.label<InputLabelProps>`
  ${BodySmallMedium};
  display: block;
  margin-bottom: 8px;
  color: ${LayoutColors.blackMain};
`;

interface InputAttributeProps {
  $issetError: boolean;
  errorContext?: string;
  label?: string;
}

export const InputAttribute = styled.input<InputAttributeProps>`
  ${InputSpacing};
  width: 100%;
  border-color: ${(props) => (props.$issetError ? LayoutColors.errorDark : LayoutColors.blackLight)};
`;
